import { render, staticRenderFns } from "./CollarModeDisplay.vue?vue&type=template&id=25621e64&scoped=true&"
import script from "./CollarModeDisplay.vue?vue&type=script&lang=js&"
export * from "./CollarModeDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CollarModeDisplay.vue?vue&type=style&index=0&id=25621e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25621e64",
  null
  
)

export default component.exports